import { render, staticRenderFns } from "./_Login.vue?vue&type=template&id=24955ba9&scoped=true&"
import script from "./_Login.vue?vue&type=script&lang=js&"
export * from "./_Login.vue?vue&type=script&lang=js&"
import style0 from "./_Login.vue?vue&type=style&index=0&id=24955ba9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24955ba9",
  null
  
)

export default component.exports